import { Edit, SimpleForm } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditEmailGroups = () => {
  return (
    <Edit
      title="Редакция на имейл група"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm edit={true}/>
      </SimpleForm>
    </Edit>
  );
};
export default EditEmailGroups;
